module.exports = __webpack_public_path__ + "static/media/mike-montgomery-mXkafXEgOlk-unsplash.503e97cb.jpg";